import { render, staticRenderFns } from "./AddStorageLocation.vue?vue&type=template&id=351c033f"
import script from "./AddStorageLocation.vue?vue&type=script&lang=js"
export * from "./AddStorageLocation.vue?vue&type=script&lang=js"
import style0 from "./AddStorageLocation.vue?vue&type=style&index=0&id=351c033f&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports